import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { DOCSIGN_API_ERROR_CODES } from '../../../constants';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH, ESIGN_BANNER_ARG } from './docsign-muster-constants';
import { variable } from '@dbk-legacy/muster/helpers';

export default () => {
  return muster() 
    .path('docsign.showUserBanner', {
      call: async ({ req }, { get, set }) => {
        const banner = ESIGN_BANNER_ARG;
        const inputs = `${banner}`;
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`${DOCSIGN_PATH}.showUserBanner["${inputs}"]["${guidStr}"]`));
         isValidJsonString(result).then(async (showDocsignBannerResponse) => {
           if(showDocsignBannerResponse){
            if(showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS){
              await set('docsign.showDocsignBanner', showDocsignBannerResponse.data.showBanner === 'Y');
              await set('docsign.firstTimeSubscription', showDocsignBannerResponse.data.showBanner === 'Y');
            } else if (showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docsign.errorMsg', messages['app.docsign.nodata.response']);
            } else {
              await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
            }
           } else {
             await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
           }
         }).catch(async () => {
          await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
        });
      }
    })
    .path('docsign.saveUserSeenBanner', {
      call: async ({ req }, { get, set }) => {
        const inputs = ESIGN_BANNER_ARG;
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`${DOCSIGN_PATH}.saveUserSeenBanner["${inputs}"]["${guidStr}"]`));
         isValidJsonString(result).then(async (saveUserSeenBannerResponse) => {
           if(saveUserSeenBannerResponse) {
             if(saveUserSeenBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || saveUserSeenBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS){
              
            } else if (saveUserSeenBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || saveUserSeenBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
            } else {
              await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
            }
           } else {
             await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
           }
         }).catch(async (err) => {
          await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
        });
      },
    })
    .path('docsign.showDocsignBanner', variable(false))
    .path('docsign.docsignBannerSeen', variable(false))
    .path('docsign.errorMsg', variable(''));
};